import { lazy } from "react";
import {
  RouterProvider,
  createBrowserRouter,
  useRouteError,
} from "react-router-dom";
import Loadable from "./components/Loadable";
// import Login from "./pages/Login";
import MainLayout from "./layouts/MainLayout";
// import UserList from "./pages/Users/UserList";
import "./App.css";
import { Box } from "@mui/material";
import Login from "./pages/Login";
/*HR Management*/
import HrmsMainLayout from "./layouts/HrmsMainLayout";

import { UserApplication } from "./pages/HRMS/Users/UserApplication";
import Protected from "./components/Protected";
import ExpoSuccess from "./pages/ExpoSuccess";

const HrDashboard = Loadable(
  lazy(() => import("./pages/HRMS/Dashboard/Dashboard"))
);
const HrAddUser = Loadable(lazy(() => import("./pages/HRMS/Users/AddUser")));
const Attendance = Loadable(
  lazy(() => import("./pages/HRMS/Attendence/Attendance"))
);
const AgentAttendence = Loadable(
  lazy(() => import("./pages/HRMS/Attendence/AgentAttendence"))
);
const UserPermission = Loadable(
  lazy(() => import("./pages/HRMS/Users/UserPermission"))
);
const User = Loadable(lazy(() => import("./pages/HRMS/Users/User")));
const UserDetails = Loadable(
  lazy(() => import("./pages/HRMS/Users/UserDetails"))
);
const UserUpdate = Loadable(
  lazy(() => import("./pages/HRMS/Users/UserUpdate"))
);
const AttendenceDetails = Loadable(
  lazy(() => import("./pages/HRMS/Attendence/AttendenceDetails"))
);
const AllLeaveList = Loadable(
  lazy(() => import("./pages/HRMS/Leaves/AllLeaveList"))
);
const AddLeave = Loadable(lazy(() => import("./pages/HRMS/Leaves/AddLeave")));
const LeaveDetails = Loadable(
  lazy(() => import("./pages/HRMS/Leaves/LeaveDetails"))
);
const Interview = Loadable(
  lazy(() => import("./pages/HRMS/Interview/Interview"))
);
const HrAddInterview = Loadable(
  lazy(() => import("./pages/HRMS/Interview/AddInterview"))
);
const HrPostInterview = Loadable(
  lazy(() => import("./pages/HRMS/Interview/PostInterview"))
);
const InterviewDetail = Loadable(
  lazy(() => import("./pages/HRMS/Interview/InterviewDetail"))
);
const Departments = Loadable(
  lazy(() => import("./pages/HRMS/Payroll/Departments"))
);
const DepartmentDetails = Loadable(
  lazy(() => import("./pages/HRMS/Payroll/Departments/DepartmentDetails"))
);
const EmployeesByDept = Loadable(
  lazy(() => import("./pages/HRMS/Payroll/Departments/EmployeesByDept"))
);
const AddDepartment = Loadable(
  lazy(() => import("./pages/HRMS/Payroll/Departments/AddDepartment"))
);
const AssignUsers = Loadable(
  lazy(() => import("./pages/HRMS/Payroll/Departments/AssignUsers"))
);
const Shift = Loadable(lazy(() => import("./pages/HRMS/Shift/Shift")));
const AddShift = Loadable(lazy(() => import("./pages/HRMS/Shift/AddShift")));
const AssignShift = Loadable(
  lazy(() => import("./pages/HRMS/Shift/AssignShift"))
);
const ViewDepartment = Loadable(
  lazy(() => import("./pages/HRMS/Shift/ViewDepartment"))
);
const ViewEmployees = Loadable(
  lazy(() => import("./pages/HRMS/Shift/ViewEmployees"))
);

const OffDays = Loadable(lazy(() => import("./pages/HRMS/OffDays/OffDays")));
const AddOffDays = Loadable(
  lazy(() => import("./pages/HRMS/OffDays/AddOffDays"))
);
const Allowance = Loadable(
  lazy(() => import("./pages/HRMS/Allowance/Allowance"))
);
const AddGroup = Loadable(
  lazy(() => import("./pages/HRMS/Allowance/AddGroup"))
);
const ViewAllowance = Loadable(
  lazy(() => import("./pages/HRMS/Allowance/ViewAllowance"))
);
const AddAllowance = Loadable(
  lazy(() => import("./pages/HRMS/Allowance/AddAllowance"))
);
const Projects = Loadable(lazy(() => import("./pages/Projects/ProjectList")));
const AddProject = Loadable(
  lazy(() => import("./pages/Projects/CreateProject"))
);
const ProjectDetails = Loadable(
  lazy(() => import("./pages/Projects/PaymentDetails"))
);

const Payments = Loadable(lazy(() => import("./pages/Payments/PaymentList")));
const PaymentDetails = Loadable(
  lazy(() => import("./pages/Payments/PaymentDetails"))
);

const About = Loadable(lazy(() => import("./pages/About/index")));
const PrivacyPolicy = Loadable(
  lazy(() => import("./pages/PrivacyPolicy/PrivacyPolicy"))
);

const Forget = Loadable(lazy(() => import("./pages/Forget/ForgetPassword")));
const Dashboard = Loadable(lazy(() => import("./pages/Dashboard")));
const UserList = Loadable(lazy(() => import("./pages/Users/UserList")));
const AddUser = Loadable(lazy(() => import("./pages/Users/AddUser")));
const AddTeam = Loadable(lazy(() => import("./pages/Teams/AddTeam")));
const TeamList = Loadable(lazy(() => import("./pages/Teams/TeamList")));
const LeadList = Loadable(lazy(() => import("./pages/Leads/LeadList")));
const LeadPool = Loadable(lazy(() => import("./pages/Leads/LeadPool")));
const AddLead = Loadable(lazy(() => import("./pages/Leads/AddLead")));
const LeadDetails = Loadable(lazy(() => import("./pages/Leads/LeadDetails")));
const MeetingList = Loadable(
  lazy(() => import("./pages/Meetings/MeetingList"))
);
const AddMeeting = Loadable(lazy(() => import("./pages/Meetings/AddMeeting")));
const MeetingDetails = Loadable(
  lazy(() => import("./pages/Meetings/MeetingDetails"))
);
const AddBooking = Loadable(lazy(() => import("./pages/Bookings/AddBooking")));
const BookingList = Loadable(
  lazy(() => import("./pages/Bookings/BookingList"))
);
const BookingDetails = Loadable(
  lazy(() => import("./pages/Bookings/BookingDetails"))
);
const EventsList = Loadable(lazy(() => import("./pages/Events/EventsList")));
const EventDetails = Loadable(
  lazy(() => import("./pages/Events/EventDetails"))
);
const AddEvent = Loadable(lazy(() => import("./pages/Events/AddEvent")));

const EventRegList = Loadable(
  lazy(() => import("./pages/EventRegistrations/EventRegList"))
);
const EventRegDetails = Loadable(
  lazy(() => import("./pages/EventRegistrations/EventRegDetails"))
);

const DeveloperList = Loadable(
  lazy(() => import("./pages/Developers/DeveloperList"))
);
const ExpenseCatList = Loadable(
  lazy(() => import("./pages/Expense/ExpenseCatList"))
);
const ExpenseCategory = Loadable(
  lazy(() => import("./pages/Expense/ExpenseCategory"))
);
const ExpenseListDetails = Loadable(
  lazy(() => import("./pages/Expense/ExpenseListDetails"))
);
const ExpenseList = Loadable(lazy(() => import("./pages/Expense/ExpenseList")));
const AddExpenses = Loadable(lazy(() => import("./pages/Expense/AddExpenses")));
const ExpenseCatDetails = Loadable(
  lazy(() => import("./pages/Expense/ExpenseCatDetails"))
);

// Invoice list
const InvoiceList = Loadable(lazy(() => import("./pages/Invoice/InvoiceList")));
const AddInvoice = Loadable(lazy(() => import("./pages/Invoice/AddInvoice")));
const InvoiceDetails = Loadable(
  lazy(() => import("./pages/Invoice/InvoiceDetails"))
);

//LeadPool List
const LeadListPool = Loadable(
  lazy(() => import("./pages/LeadPool/LeadPoolList"))
);

//Incentive LIst
const InventiveLIst = Loadable(
  lazy(() => import("./pages/Incentive/IncentiveList"))
);

//Team Incentive List
const TeamIncentiveList = Loadable(
  lazy(() => import("./pages/TeamIncentive/TeamIncentive"))
);
const TeamIncentiveDetail = Loadable(
  lazy(() => import("./pages/TeamIncentive/TeamIncentiveDetail"))
);

const InventiveDetails = Loadable(
  lazy(() => import("./pages/Incentive/IncentiveDetails"))
);

//ReferralList
const ReferralList = Loadable(
  lazy(() => import("./pages/Referral/ReferralList"))
);
const ReferralDetails = Loadable(
  lazy(() => import("./pages/Referral/ReferralDetails"))
);
const ReferralEdit = Loadable(
  lazy(() => import("./pages/Referral/ReferralEdit"))
);

// hrms/holiday
const Holidays = Loadable(lazy(() => import("./pages/HRMS/Holidays/Holidays")));
const AddHoliday = Loadable(
  lazy(() => import("./pages/HRMS/Holidays/AddHoliday"))
);
const AssignHoliday = Loadable(
  lazy(() => import("./pages/HRMS/Holidays/AssignHoliday"))
);
const HolidayDetail = Loadable(
  lazy(() => import("./pages/HRMS/Holidays/HolidayDetail"))
);
const UserHolidayDetail = Loadable(
  lazy(() => import("./pages/HRMS/Holidays/UserHolidayDetail"))
);

const DepartmentHolidayDetail = Loadable(
  lazy(() => import("./pages/HRMS/Holidays/DepartmentHolidayDetail"))
);

// hrms/salary
const SalarySlips = Loadable(
  lazy(() => import("./pages/HRMS/SalarySlip/SalarySlips"))
);
const SalarySlipDetails = Loadable(
  lazy(() => import("./pages/HRMS/SalarySlip/SalarySlipDetails"))
);
const DetailForm = Loadable(lazy(() => import("./pages/DubaiExpoForm")));
const GenerateTicket = Loadable(lazy(() => import("./pages/GenerateTicket")));

function App() {
  const router = createBrowserRouter([
    {
      path: "/auth/login",
      element: <Login />,
    },
    {
      path: "/auth/forget",
      element: <Forget />,
    },
    {
      path: "about",
      element: <About />,
    },
    {
      path: "privacy-policy",
      element: <PrivacyPolicy />,
    },
    {
      path: "expo-form",
      element: <DetailForm />,
    },
    {
      path: "generated-ticket",
      element: <GenerateTicket />,
    },
    {
      path: "expo-success",
      element: <ExpoSuccess />,
    },
    {
      path: "userApplication",
      element: <Protected />,
      children: [
        {
          path: "",
          element: <UserApplication />,
        },
      ],
    },

    {
      path: "/HrManagement",
      element: <Protected />,
      children: [
        {
          path: "",
          element: <HrmsMainLayout />,
          children: [
            {
              path: "dashboard",
              element: <HrDashboard />,
            },
            {
              path: "users",
              element: <User />,
            },
            {
              path: "addUser",
              element: <HrAddUser />,
            },
            {
              path: "userDetails/:id",
              element: <UserDetails />,
            },
            {
              path: "userUpdate",
              element: <UserUpdate />,
            },
            {
              path: "userPermission/:id",
              element: <UserPermission />,
            },
            {
              path: "attendance",
              element: <Attendance />,
            },
            {
              path: "individualAtt/:id",
              element: <AgentAttendence />,
            },
            {
              path: "attendenceDetails/:id",
              element: <AttendenceDetails />,
            },
            {
              path: "leaves",
              element: <AllLeaveList />,
            },
            {
              path: "addLeave",
              element: <AddLeave />,
            },
            {
              path: "leaveDetails/:id",
              element: <LeaveDetails />,
            },
            {
              path: "interview",
              element: <Interview />,
            },
            {
              path: "addInterview",
              element: <HrAddInterview />,
            },
            {
              path: "postInterview",
              element: <HrPostInterview />,
            },
            {
              path: "interviewDetail/:id",
              element: <InterviewDetail />,
            },
            {
              path: "payroll/department",
              element: <Departments />,
            },
            {
              path: "payroll/department/addDepartment",
              element: <AddDepartment />,
            },
            {
              path: "payroll/department/assignUsers",
              element: <AssignUsers />,
            },
            {
              path: "payroll/department/employeesByDepartment",
              element: <EmployeesByDept />,
            },
            {
              path: "payroll/department/:id",
              element: <DepartmentDetails />,
            },
            {
              path: "shift",
              element: <Shift />,
            },
            {
              path: "addShift",
              element: <AddShift />,
            },
            {
              path: "addShift/:id",
              element: <AddShift />,
            },
            {
              path: "viewDepartment/:id",
              element: <ViewDepartment />,
            },
            {
              path: "assignShift",
              element: <AssignShift />,
            },
            {
              path: "viewEmployees/:id",
              element: <ViewEmployees />,
            },
            {
              path: "offDays",
              element: <OffDays />,
            },
            {
              path: "addOffDays",
              element: <AddOffDays />,
            },
            {
              path: "allowance",
              element: <Allowance />,
            },
            {
              path: "addGroup",
              element: <AddGroup />,
            },
            {
              path: "addGroup/:id",
              element: <AddGroup />,
            },
            {
              path: "addGroup/viewAllowance/:id",
              element: <ViewAllowance />,
            },
            {
              path: "addAllowance",
              element: <AddAllowance />,
            },
            {
              path: "addAllowance/:id",
              element: <AddAllowance />,
            },

            {
              path: "holidays",
              element: <Holidays />,
            },
            {
              path: "holidays/add",
              element: <AddHoliday />,
            },
            {
              path: "holidays/assign",
              element: <AssignHoliday />,
            },
            {
              path: "holidays/details/:id",
              element: <HolidayDetail />,
            },
            {
              path: "holidays/user-details/:id",
              element: <UserHolidayDetail />,
            },
            {
              path: "holidays/department-details/:id",
              element: <DepartmentHolidayDetail />,
            },
            {
              path: "salary-slips",
              element: <SalarySlips />,
            },
            {
              path: "salary-slips/details/:id",
              element: <SalarySlipDetails />,
            },
          ],
        },
      ],
    },
    {
      path: "/",
      element: <MainLayout />,
      errorElement: <ErrorBoundary />,
      children: [
        {
          path: "dashboard",
          element: <Dashboard />,
        },
        {
          path: "project",
          element: <Projects />,
        },
        {
          path: "project/create-project",
          element: <AddProject />,
        },
        {
          path: "payment",
          element: <Payments />,
        },
        {
          path: "payment/payment-details",
          element: <PaymentDetails />,
        },
        {
          path: "project/:id",
          element: <ProjectDetails />,
        },
        {
          path: "users",
          element: <UserList />,
        },
        {
          path: "users/addUser",
          element: <AddUser />,
        },
        {
          path: "users/addTeam",
          element: <AddTeam />,
        },
        {
          path: "users/teams",
          element: <TeamList />,
        },
        {
          path: "leads",
          element: <LeadList />,
        },
        {
          path: "leads/leadpool",
          element: <LeadPool />,
        },
        {
          path: "leads/:id",
          element: <LeadDetails />,
        },
        {
          path: "leads/addLead",
          element: <AddLead />,
        },
        {
          path: "meetings",
          element: <MeetingList />,
        },
        {
          path: "meetings/addMeeting",
          element: <AddMeeting />,
        },
        {
          path: "meetings/:id",
          element: <MeetingDetails />,
        },
        {
          path: "events",
          element: <EventsList />,
        },
        {
          path: "events/add",
          element: <AddEvent />,
        },
        {
          path: "events/:id",
          element: <EventDetails />,
        },
        {
          path: "eventReg",
          element: <EventRegList />,
        },
        {
          path: "eventReg/:id",
          element: <EventRegDetails />,
        },

        {
          path: "bookings",
          element: <BookingList />,
        },
        {
          path: "bookings/addBooking",
          element: <AddBooking />,
        },
        {
          path: "bookings/:id",
          element: <BookingDetails />,
        },
        {
          path: "developers",
          element: <DeveloperList />,
        },
        {
          path: "expense",
          element: <ExpenseCatList />,
        },
        {
          path: "expense/add-category",
          element: <ExpenseCategory />,
        },
        {
          path: "expense/category-details/:id",
          element: <ExpenseCatDetails />,
        },
        {
          path: "expense/expense-list",
          element: <ExpenseList />,
        },
        {
          path: "expense/add-expense",
          element: <AddExpenses />,
        },
        {
          path: "expense/expense-details/:id",
          element: <ExpenseListDetails />,
        },
        {
          path: "invoice",
          element: <InvoiceList />,
        },
        {
          path: "invoice/add-invoice",
          element: <AddInvoice />,
        },
        {
          path: "invoice/invoice-details/:id",
          element: <InvoiceDetails />,
        },
        {
          path: "lead-pool",
          element: <LeadListPool />,
        },
        {
          path: "incentive",
          element: <InventiveLIst />,
        },
        {
          path: "incentive/details/:id",
          element: <InventiveDetails />,
        },
        {
          path: "team-incentive",
          element: <TeamIncentiveList />,
        },
        {
          path: "team-incentive/:id",
          element: <TeamIncentiveDetail />,
        },
        {
          path: "referral",
          element: <ReferralList />,
        },
        {
          path: "referral/:id",
          element: <ReferralDetails />,
        },
        {
          path: "referral/add-referral",
          element: <ReferralEdit />,
        },
      ],
    },
  ]);

  return <RouterProvider router={router} />;
}

function ErrorBoundary() {
  let error = useRouteError();
  console.error(error);
  // Uncaught ReferenceError: path is not defined
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        textAlign: "center",
        backgroundColor: "#f8f8f8",
      }}
    >
      <h1>An error occurred</h1>
      <p>Sorry, something went wrong.</p>
    </Box>
  );
}
export default App;
